import { Routes } from "@angular/router";

import { ShellFacadeGuard } from "@hermes/hermes-web-fragments-shell";
import {
    CustomerSessionResolver,
    LocalePrefixGuard,
    XsrfTokenResolver,
} from "@hermes/core-router-components";

import { SHELL_APPEARANCE_FULL } from "@hermes/utils-generic-constants";

import { APP_CHILD_ROUTES } from "./app-child.routes";

export const APP_ROUTES: Routes = [
    {
        // check url for locale prefix for every route.
        path: "",
        canActivateChild: [LocalePrefixGuard, ShellFacadeGuard],
        resolve: {
            customerSession: CustomerSessionResolver,
            xsrf: XsrfTokenResolver,
        },
        children: APP_CHILD_ROUTES,
        data: {
            shell: SHELL_APPEARANCE_FULL,
        },
    },
];
